<template>
  <div class="pagina ativa" id="paginaPagamentos">
    <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:25px;border-bottom:2px solid #4a5c2f;padding-bottom:10px;flex-wrap:wrap;gap:10px;">
      <div style="font-size:22px;font-weight:bold;color:#4a5c2f;">Pagamentos de Comissoes</div>
      <button @click="gerarPDFPagamentos" style="margin-top:0;padding:8px 18px;font-size:13px;">Gerar PDF Vendedor</button>
    </div>
    <div style="background:white;padding:15px 20px;border-radius:10px;box-shadow:0 2px 8px rgba(0,0,0,0.08);margin-bottom:20px;display:flex;gap:15px;flex-wrap:wrap;align-items:flex-end;">
      <div><label>Data Venda De</label><input type="date" v-model="filtros.dataInicio" style="width:155px;" /></div>
      <div><label>Data Venda Ate</label><input type="date" v-model="filtros.dataFim" style="width:155px;" /></div>
      <div><label>Importação (dd/mm/aaaa)</label><input type="text" v-model="filtros.dataImportacao" placeholder="Ex: 10/08/2025" style="width:150px;" /></div>
      <div>
        <label>Vendedor</label>
        <select v-model="filtros.vendedor" style="width:200px;">
          <option value="">Todos</option>
          <option v-for="v in vendedoresUnicos" :key="v" :value="v">{{ v }}</option>
        </select>
      </div>
      <div>
        <label>Status</label>
        <select v-model="filtros.status" style="width:140px;">
          <option value="">Todos</option>
          <option value="pendente">Pendente</option>
          <option value="pago">Pago</option>
        </select>
      </div>
      <div><label>Cliente</label><input type="text" v-model="filtros.cliente" placeholder="Nome do cliente..." style="width:180px;" /></div>
      <div><button @click="limparFiltros" style="margin-top:0;padding:10px 18px;font-size:13px;background:#888;">Limpar</button></div>
    </div>
    <div class="grid-cards" style="margin-bottom:20px;">
      <div class="card"><div class="card-label">Total</div><div class="card-valor">{{ resumo.total }}</div></div>
      <div class="card"><div class="card-label">Valor</div><div class="card-valor">{{ fmtBRL(resumo.valor) }}</div></div>
      <div class="card"><div class="card-label">Pendentes</div><div class="card-valor" style="color:#e67e22;">{{ fmtBRL(resumo.pendentes) }}</div></div>
      <div class="card"><div class="card-label">Pagos</div><div class="card-valor" style="color:#27ae60;">{{ fmtBRL(resumo.pagos) }}</div></div>
    </div>
    <div style="overflow-x:auto;">
      <table class="tabela-dash">
        <thead><tr><th>Data</th><th>Vendedor</th><th>Cliente</th><th>Grupo</th><th>Cota</th><th>Parc.</th><th>Credito</th><th>Liquido</th><th>Status</th><th>Acoes</th></tr></thead>
        <tbody>
          <tr v-if="carregando"><td colspan="10" style="padding:20px;text-align:center;color:#888;">Carregando...</td></tr>
          <tr v-else-if="pagamentosFiltrados.length === 0"><td colspan="10" style="padding:20px;text-align:center;color:#888;">Nenhum registro.</td></tr>
          <tr v-for="p in pagamentosFiltrados" :key="p.chave">
            <td style="padding:8px;">{{ formatarData(p.dataVenda) }}</td>
            <td style="padding:8px;font-weight:bold;">{{ p.vendedor }}</td>
            <td style="padding:8px;">{{ p.cliente }}</td>
            <td style="padding:8px;color:#666;">{{ p.grupo }}</td>
            <td style="padding:8px;font-weight:bold;color:#4a5c2f;">{{ p.cota }}</td>
            <td style="padding:8px;color:#3498db;font-weight:bold;">{{ p.parcelaInfo || '--' }}</td>
            <td style="padding:8px;font-weight:bold;color:#2e5016;">{{ creditoDaVenda(p) }}</td>
            <td style="padding:8px;">{{ fmtBRL(p.comissaoLiquido) }}</td>
            <td style="padding:8px;">
              <span :style="{ background: ehPago(p) ? '#27ae60' : '#e67e22', color: 'white', padding: '3px 10px', borderRadius: '10px', fontSize: '11px', fontWeight: 'bold' }">{{ ehPago(p) ? 'PAGO' : 'PENDENTE' }}</span>
            </td>
            <td style="padding:8px;">
              <button @click="marcarUnico(p)" :style="{ padding: '4px 10px', fontSize: '11px', background: ehPago(p) ? '#e67e22' : '#27ae60', marginTop: '0', border: 'none', color: 'white', borderRadius: '4px', cursor: 'pointer' }">{{ ehPago(p) ? 'Desfazer' : 'Pagar' }}</button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { apiGet, apiPost, apiPublicGet, getNomeEmpresaCache } from '../api'

export default {
  name: 'PaginaPagamentos',
  data() {
    return {
      pagamentos: [],
      vendas: [],
      usuarios: [],
      logoUrl: '',
      carregando: true,
      filtros: { dataInicio: '', dataFim: '', vendedor: '', status: '', cliente: '', dataImportacao: '' }
    }
  },
  computed: {
    vendedoresUnicos() {
      const s = new Set(this.pagamentos.map(p => p.vendedor).filter(Boolean))
      return Array.from(s).sort()
    },
    pagamentosFiltrados() {
      let d = this.pagamentos.slice()
      const f = this.filtros
      if (f.dataInicio) d = d.filter(p => p.dataVenda >= f.dataInicio)
      if (f.dataFim) d = d.filter(p => p.dataVenda <= f.dataFim)
      if (f.vendedor) d = d.filter(p => p.vendedor === f.vendedor)
      if (f.status) d = d.filter(p => (p.statusPagamento || 'pendente').toLowerCase() === f.status)
      if (f.cliente) d = d.filter(p => (p.cliente || '').toLowerCase().indexOf(f.cliente.toLowerCase()) > -1)
      if (f.dataImportacao && f.dataImportacao.trim().length === 10) d = d.filter(p => this.formatarDataImportacao(p.dataImportacao).indexOf(f.dataImportacao.trim()) > -1)
      d.sort((a, b) => b.dataVenda.localeCompare(a.dataVenda))
      return d
    },
    resumo() {
      const d = this.pagamentosFiltrados
      let valor = 0, pendentes = 0, pagos = 0
      d.forEach(p => {
        const v = parseFloat(p.comissaoLiquido) || 0
        valor += v
        if ((p.statusPagamento || 'pendente').toLowerCase() === 'pendente') pendentes += v
        else pagos += v
      })
      return { total: d.length, valor, pendentes, pagos }
    }
  },
  created() {
    this.carregar()
  },
  methods: {
    fmtBRL(v) {
      return 'R$ ' + (parseFloat(v) || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    formatarData(iso) {
      if (!iso) return '--'
      const p = iso.toString().substring(0, 10).split('-')
      return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : iso
    },
    formatarDataImportacao(v) {
      if (!v) return ''
      const p = v.toString().substring(0, 10).split('-')
      return p.length === 3 ? p[2] + '/' + p[1] + '/' + p[0] : v.toString()
    },
    ehPago(p) {
      return (p.statusPagamento || 'pendente').toLowerCase() === 'pago'
    },
    creditoDaVenda(p) {
      let v = this.vendas.find(x => !x.isFilha && x.grupo && p.grupo && x.grupo.toString().trim() === p.grupo.toString().trim() && x.cota && p.cota && x.cota.toString().trim() === p.cota.toString().trim())
      if (!v && p.cota) v = this.vendas.find(x => !x.isFilha && x.contrato && x.contrato.toString().trim() === p.cota.toString().trim())
      if (!v) v = this.vendas.find(x => !x.isFilha && x.cliente && p.cliente && x.cliente.toLowerCase().trim() === p.cliente.toLowerCase().trim())
      const cred = v ? (v.valor || 0) : 0
      return cred > 0 ? this.fmtBRL(cred) : '—'
    },
    limparFiltros() {
      this.filtros = { dataInicio: '', dataFim: '', vendedor: '', status: '', cliente: '', dataImportacao: '' }
    },
    async carregar() {
      this.carregando = true
      const [rp, rv, ru] = await Promise.all([apiGet('pagamentos/listar'), apiGet('vendas/listar'), apiGet('usuarios/listar-admin')])
      if (rp.sucesso) this.pagamentos = rp.pagamentos
      if (rv.sucesso) this.vendas = rv.vendas
      if (ru.sucesso) this.usuarios = ru.usuarios
      apiPublicGet('config/logo-publico', { empresa: 'm-consorcios' }).then(r => { if (r.sucesso && r.valor) this.logoUrl = r.valor })
      this.carregando = false
    },
    gerarPDFPagamentos() {
      const d = this.pagamentosFiltrados
      if (!d.length) { alert('Nenhum dado com os filtros atuais.'); return }
      let tBruto = 0, tLiquido = 0
      const fVNome = this.filtros.vendedor || 'Todos'
      let filtrosDesc = ''
      if (this.filtros.dataImportacao) filtrosDesc += 'Importação: ' + this.filtros.dataImportacao + ' &nbsp;|&nbsp; '
      if (this.filtros.dataInicio) filtrosDesc += 'Venda de: ' + this.formatarData(this.filtros.dataInicio) + ' &nbsp;|&nbsp; '
      if (this.filtros.dataFim) filtrosDesc += 'até: ' + this.formatarData(this.filtros.dataFim) + ' &nbsp;|&nbsp; '
      filtrosDesc += 'Vendedor: ' + fVNome
      if (this.filtros.status) filtrosDesc += ' &nbsp;|&nbsp; Status: ' + this.filtros.status
      const linhas = d.map(v => {
        const liq = parseFloat(v.comissaoLiquido) || 0
        const bruto = liq / 0.85
        tBruto += bruto; tLiquido += liq
        const dataF = this.formatarData(v.dataVenda)
        const credStr = this.creditoDaVenda(v)
        return '<tr><td>' + dataF + '</td><td>' + v.vendedor + '</td><td>' + v.cliente + '</td><td>' + (v.grupo || '--') + '</td><td>' + (v.cota || '--') + '</td><td style="font-weight:bold;color:#3498db;">' + (v.parcelaInfo || '--') + '</td><td style="font-weight:bold;color:#2e5016;">' + credStr + '</td><td class="valor">R$ ' + bruto.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '</td></tr>'
      }).join('')
      const tImposto = tBruto - tLiquido
      const dataEmissao = new Date().toLocaleDateString('pt-BR')
      const imgTag = this.logoUrl ? '<img src="' + this.logoUrl + '" style="max-width:100px;margin-bottom:8px;" />' : ''
      let pagamentoBar = ''
      if (this.filtros.vendedor) {
        const u = this.usuarios.find(x => x.nome === this.filtros.vendedor)
        if (u && u.pixChave) {
          pagamentoBar = '<div class="pix-bar">💰 Pagar para: <strong>' + (u.nomeBanco || u.nome) + '</strong> &nbsp;|&nbsp; Chave PIX: <strong>' + u.pixChave + '</strong></div>'
        }
      }
      const html = '<!DOCTYPE html><html><head><meta charset="UTF-8"><style>@media print{body{margin:0;padding:0}@page{margin:10mm;size:A4}}body{font-family:"Segoe UI",Tahoma,sans-serif;margin:0;padding:10px;background:#f5f5f0}.container{max-width:900px;margin:0 auto;background:white;padding:15px;border-radius:8px;box-shadow:0 2px 8px rgba(0,0,0,0.1)}.header{text-align:center;margin-bottom:15px;border-bottom:2px solid #4a5c2f;padding-bottom:12px}.header h1{color:#4a5c2f;margin:8px 0 3px;font-size:24px;font-weight:bold}.header p{color:#666;margin:2px 0;font-size:11px}.filtros-bar{background:#f0f4e8;border:1px solid #c8d8b0;border-radius:6px;padding:7px 12px;font-size:10px;color:#555;margin-bottom:12px;}.pix-bar{background:#e8f5e9;border:1px solid #a5d6a7;border-radius:6px;padding:9px 12px;font-size:12px;color:#1b5e20;margin-bottom:12px;}table{width:100%;border-collapse:collapse;margin-bottom:12px;font-size:10px}thead th{background:#4a5c2f;color:white;padding:6px;text-align:left;font-size:9px}tbody td{padding:4px 6px;border-bottom:0.5px solid #e0e0e0}tbody tr:nth-child(even){background:#f9f9f9}.valor{text-align:right;font-family:"Courier New",monospace;font-weight:500}.total-section{margin-top:10px;border-top:1px solid #4a5c2f;padding-top:8px}.total-row{background:#e8f0fe;padding:6px;margin-bottom:4px;display:flex;justify-content:space-between;border-radius:3px;border-left:3px solid #4a5c2f;font-size:11px}.total-liquido{background:#e8f5e9;padding:10px;border-radius:4px;display:flex;justify-content:space-between;align-items:center;border-left:4px solid #27ae60;margin-top:8px}.total-liquido strong{color:#27ae60;font-size:13px;font-weight:bold}.total-liquido .valor{font-size:15px;color:#27ae60;font-weight:bold}.footer{text-align:center;font-size:9px;color:#999;margin-top:12px;border-top:0.5px solid #e0e0e0;padding-top:8px}</style></head><body><div class="container"><div class="header">' + imgTag + '<h1>' + getNomeEmpresaCache() + '</h1><p>Comprovante de Comissão de Vendas</p></div><div class="filtros-bar">📋 Filtros: ' + filtrosDesc + '</div>' + pagamentoBar + '<table><thead><tr><th>Data</th><th>Vendedor</th><th>Cliente</th><th>Grupo</th><th>Cota</th><th>Parcelas</th><th>Crédito</th><th class="valor">Comissão Bruta</th></tr></thead><tbody>' + linhas + '</tbody></table><div class="total-section"><div class="total-row"><strong>Total Bruto:</strong><span class="valor">R$ ' + tBruto.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '</span></div><div class="total-row" style="border-left:4px solid #c0392b;"><strong>Imposto Federal (15%):</strong><span class="valor" style="color:#c0392b;">- R$ ' + tImposto.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '</span></div><div class="total-liquido"><strong>💰 TOTAL LÍQUIDO A RECEBER</strong><span class="valor">R$ ' + tLiquido.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '</span></div></div><div class="footer"><p>Gerado em: ' + dataEmissao + ' | ' + getNomeEmpresaCache() + '</p></div></div></body></html>'
      const w = window.open('', '_blank')
      w.document.write(html)
      w.document.close()
    },
    async marcarUnico(p) {
      const statusAtual = (p.statusPagamento || 'pendente').toLowerCase()
      const novoStatus = statusAtual === 'pendente' ? 'pago' : 'pendente'
      const acao = novoStatus === 'pago' ? 'marcar como PAGO' : 'DESFAZER pagamento'
      const pendentesVendedor = this.pagamentos.filter(x => x.vendedor === p.vendedor && (x.statusPagamento || 'pendente').toLowerCase() === statusAtual)

      let opcao = 1
      if (pendentesVendedor.length > 1) {
        const resp = prompt('O que deseja fazer?\n\n1 = ' + acao + ' SOMENTE esta cota\n2 = ' + acao + ' TODAS as ' + pendentesVendedor.length + ' cotas de ' + p.vendedor + '\n\nDigite 1 ou 2:')
        if (!resp) return
        opcao = parseInt(resp)
        if (opcao !== 1 && opcao !== 2) { alert('Opcao invalida.'); return }
      } else {
        if (!confirm('Deseja ' + acao + ' este registro?\n\nChave: ' + p.chave)) return
      }

      if (opcao === 1) {
        const r = await apiPost('pagamentos/marcar', { chave: p.chave, status: novoStatus, vendedor: p.vendedor, cota: p.cota, parcela: p.parcela })
        if (r.sucesso) {
          this.pagamentos.forEach(x => { if (x.chave.trim() === p.chave.trim()) x.statusPagamento = novoStatus })
        } else {
          alert('ERRO: ' + (r.mensagem || 'falha ao marcar'))
        }
      } else {
        const r = await apiPost('pagamentos/marcar-lote', { vendedor: p.vendedor, status: novoStatus })
        if (r.sucesso) {
          this.carregar()
        } else {
          alert('ERRO: ' + (r.mensagem || 'falha ao marcar em lote'))
        }
      }
    }
  }
}
</script>
